import { Box, CircularProgress, Dialog, DialogContent, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
interface IConfirmAppointmentModal {
  open: boolean;
}
const ConfirmAppointmentModal: React.FC<IConfirmAppointmentModal> = ({
  open
}) => {
  const {
    t
  } = useTranslation('index');
  return <Dialog open={open} disableEscapeKeyDown PaperProps={{
    sx: {
      borderRadius: {
        xs: 2,
        md: 3
      },
      maxWidth: '440px',
      width: {
        xs: '90%',
        sm: '400px'
      },
      mx: 2
    }
  }} data-sentry-element="Dialog" data-sentry-component="ConfirmAppointmentModal" data-sentry-source-file="ConfirmAppointmentModal.tsx">
			<DialogContent data-sentry-element="DialogContent" data-sentry-source-file="ConfirmAppointmentModal.tsx">
				<Stack direction="column" sx={{
        alignItems: 'center',
        textAlign: 'center',
        py: 3,
        position: 'relative'
      }} data-sentry-element="Stack" data-sentry-source-file="ConfirmAppointmentModal.tsx">
					{/* Loading spinner instead of ErrorIcon */}
					<Box sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '66px',
          height: '66px',
          borderRadius: '50%',
          backgroundColor: 'primary.50',
          mb: 1
        }} data-sentry-element="Box" data-sentry-source-file="ConfirmAppointmentModal.tsx">
						<CircularProgress size={40} thickness={3.5} sx={{
            color: 'primary.main'
          }} data-sentry-element="CircularProgress" data-sentry-source-file="ConfirmAppointmentModal.tsx" />
					</Box>

					<Typography variant="header3" sx={{
          color: 'text.primary',
          mt: 3,
          mb: 2
        }} data-sentry-element="Typography" data-sentry-source-file="ConfirmAppointmentModal.tsx">
						{t('confirmingConsultation')}
					</Typography>

					<Typography variant="bodyLargeBook" sx={{
          color: 'text.secondary',
          textAlign: 'center',
          lineHeight: 1.6,
          maxWidth: '300px'
        }} data-sentry-element="Typography" data-sentry-source-file="ConfirmAppointmentModal.tsx" />
				</Stack>
			</DialogContent>
		</Dialog>;
};
export default ConfirmAppointmentModal;